// extracted by mini-css-extract-plugin
export default {"bigNotification":"bigNotification-vcKez","icon":"icon-MUZS2","success":"success-SCki5","message":"message-IStaM","warning":"warning-OGEII","error":"error-iOW0z"};